import React, { useState } from "react";
import UsernameModal from "./UsernameModal";

const MemberAccount = ({user_account}) => {
    const [changeUsernameModal, setChangeUsernameModal] = useState(false)
  return (
    <div className="border border-gray-300 py-5 px-5">
        {
            changeUsernameModal && <UsernameModal modalOpen={changeUsernameModal} setModalOpen={setChangeUsernameModal} />
        }
      <div>
        <h3 className="text-xl font-500 border-b border-slate-400 pb-1 mb-2">
          Change Username
        </h3>
        <p>Changing your username can have unintended side effects.</p>
        <button onClick={()=>setChangeUsernameModal(true)} className="px-2 py-1 text-sm border border-gray-500 bg-gray-100 rounded-md mt-2 font-[500] hover:bg-gray-200">
          Change Username
        </button>
      </div>
      <div className="my-5">
        <div className="flex justify-between items-center border-b border-slate-400 pb-1 mb-2">
          <h3 className="text-xl font-500 ">Change Password</h3>
          <button className="px-2 py-1 text-sm border border-gray-500 bg-gray-100 rounded-md mt-2 font-[500] hover:bg-gray-200">
            Change Password
          </button>
        </div>
        <p>Strengthen your account by ensuring your password is strong.</p>
      </div>

      <div>
        <h3 className="text-xl font-500 border-b border-slate-400 pb-1 mb-2 text-red-500">
          Delete account
        </h3>
        <p>
          Once you delete this account, there is no going back. Please be
          certain.
        </p>
        <button className="p-2 py-1 text-sm border border-gray-500 bg-gray-100 rounded-md mt-2 font-[500] hover:bg-gray-200 text-red-500">
          Delete account
        </button>
      </div>
    </div>
  );
};

export default MemberAccount;
